import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-plant-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">黄瓜视频下载</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              高清视频内容聚合与资源导航平台，聚合多样视频分类与热门资源，帮助用户快速浏览、检索并了解视频条目信息。
            </p>
            <p className="mt-3 text-xs leading-relaxed text-background-300">
              本站为演示性质的视频内容聚合导航站，所有视频条目与资源均仅用于展示结构与交互，不提供真实播放或下载服务。
            </p>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">内容导航</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {categories.slice(0, 6).map((category) => (
                <li key={category.id}>
                  <Link
                    to={`/category/${category.id}`}
                    className="text-background-200 transition-colors hover:text-accent-300"
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">关于本站</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link to="/" className="text-background-200 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-background-200 transition-colors hover:text-accent-300">
                  全部视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-200 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 黄瓜视频下载 · 高清视频内容聚合与资源导航</p>
          <p>本站内容均为演示，仅供结构与交互展示使用</p>
        </div>
      </div>
    </footer>
  );
}